import React from "react";

export const Smartphone: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 40 40"
    >
      <g fillRule="nonzero">
        <path d="M20 22.598v8.235c0 .92-.746 1.667-1.667 1.667H6.667C5.747 32.5 5 31.754 5 30.833V12.5c0-.92.746-1.667 1.667-1.667h7.1a.408.408 0 00.4-.401c.032-1.096.2-2.183.5-3.237a.408.408 0 00-.385-.528H5.833a4.166 4.166 0 00-4.166 4.166v25A4.167 4.167 0 005.833 40h13.334a4.167 4.167 0 004.166-4.167V23.787a.4.4 0 00-.271-.38c-.848-.3-1.664-.687-2.434-1.152a.406.406 0 00-.628.344v-.001z" />
        <path d="M27.5 0c-5.983 0-10.833 4.85-10.833 10.833 0 5.983 4.85 10.834 10.833 10.834 5.983 0 10.833-4.85 10.833-10.834C38.326 4.853 33.48.007 27.5 0zm-5.657 12.895a1.25 1.25 0 011.769-1.767l2.5 2.5 4.841-6.456a1.25 1.25 0 012 1.499l-4.84 6.46a2.543 2.543 0 01-3.768.266l-2.502-2.502z" />
      </g>
    </svg>
  );
};
